import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles';

const RoundedBox = styled(Box) ({
    border: "1px solid #0000001F",
    borderRadius: 16, // 16px
    backgroundColor: "#21212114", // grey
    padding: "6px 12px",
    height: "32px",
    marginRight: "1rem",
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap", // Prevents line breaks
    cursor: "pointer"
});

function ModalNavItem({title, filterFunction}) {
  return (
    <RoundedBox onClick={filterFunction} >
        {title}
    </RoundedBox>
  )
}

export default ModalNavItem